// extracted by mini-css-extract-plugin
export default {"loginTopImageLayout":"Login_loginTopImageLayout__uxHia","title":"Login_title__0RZfH","amprimary":"Login_amprimary__azTRf"};